module.exports = __webpack_public_path__ + "static/media/star-default.7287f446.svg";